import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {actions} from 'redux-notifications';

import {getIconClass} from './../../utils/icons';

class Notification extends Component {

    static propTypes = {
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        message: PropTypes.node.isRequired,
        kind: PropTypes.oneOf(['success', 'info', 'warning', 'danger',]).isRequired,
        dispatch: PropTypes.func.isRequired,
        dismissAfter: PropTypes.number
    };

    static defaultProps = {
        defaultDismiss: 5000
    };

    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
    };

    close() {
        this.props.dispatch(actions.notifDismiss(this.props.id));
    };

    componentWillMount() {
        this.timer = setTimeout(this.close, this.props.dismissAfter || this.props.defaultDismiss);
    };

    componentWillUnmount() {
        this.timer && clearTimeout(this.timer);
    };

    render() {
        return (
            <div className={['foNotification', 'alert', `alert-${this.props.kind}`].join(' ')}>
                <span className="foNotificationMessage">{this.props.message}</span>
                <button type="button" className="close" onClick={this.close}>
                    <span className={getIconClass("remove")} aria-hidden="true"/>
                    <span className="sr-only">Close</span>
                </button>
            </div>
        );
    };

}

export default Notification;


// WEBPACK FOOTER //
// ./src/app/components/notification/index.js